var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCardBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 140,
    viewBox: "0 0 180 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11334_2328",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 180,
    height: 140
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.389648,
    width: 179.416,
    height: 139.5,
    fill: "#4FD1C5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11334_2328)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 181.268,
    cy: 139.684,
    r: 145.79,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181.268,
    cy: 139.684,
    r: 126.012,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181.268,
    cy: 139.684,
    r: 103.506,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181.268,
    cy: 139.684,
    r: 80.9995,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181.268,
    cy: 139.684,
    r: 59.1753,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181.268,
    cy: 139.684,
    r: 39.3972,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181.268,
    cy: 139.684,
    r: 23.573,
    stroke: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCardBg);
export default __webpack_public_path__ + "static/media/Info_Card_BG.668424d0f62aefa32aacd59f2ba89d07.svg";
export { ForwardRef as ReactComponent };